import { render, staticRenderFns } from "./ControlBajaCliente.vue?vue&type=template&id=822c415e&"
import script from "./ControlBajaCliente.vue?vue&type=script&lang=ts&"
export * from "./ControlBajaCliente.vue?vue&type=script&lang=ts&"
import style0 from "./ControlBajaCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('822c415e', component.options)
    } else {
      api.reload('822c415e', component.options)
    }
    module.hot.accept("./ControlBajaCliente.vue?vue&type=template&id=822c415e&", function () {
      api.rerender('822c415e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ControlBajaCliente/ControlBajaCliente.vue"
export default component.exports